// Helper to remove the $ from the string coming in from sku and converting it to number.
export default function priceFormatter(sku) {
  const startAtPrice = sku && sku.startsAtPrice.substr(1) * 1;

  return startAtPrice;
}

export const formatSpeeds = ({ type, units }) => {
  // https://support.ookla.com/hc/en-us/articles/115005319507-Passing-Test-Results-To-The-Browser
  // Per docs the units will always return as 'Kbps'
  if (!units) return type;
  if (units.toLowerCase() === 'kbps') return Number(type) / 1000;
  return type;
};
